import { motion } from 'framer-motion';

const fadeInUp = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.5 }
};

const TestimonialsSection = () => {
  const testimonials = [
    {
      quote: "Winery Finder is the only mobile App consistently bringing in traffic to our winery!",
      author: "Summers Estate Winery"
    },
    {
      quote: "We track traffic to our winery and see highest traffic generated via the Winery Finder App!",
      author: "Schug Carneros Estate"
    },
    {
      quote: "We have seen so much measurable success with Winery Finder that we have signed a multi-year contract!",
      author: "Domaine Chandon"
    },
    {
      quote: "When compared with YELP, we see best sales conversion rates from our campaigns on Winery Finder App!",
      author: "J Winery & Vineyards"
    }
  ];

  return (
    <section className="py-16 sm:py-24" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <motion.div 
          className="text-center mb-10 sm:mb-16"
          {...fadeInUp}
        >
          <span className="overline text-primary mb-3 sm:mb-4 block">Testimonials</span>
          <h2 className="font-serif text-3xl sm:text-4xl text-primary">
            Trusted by <span className="italic">500+ Wineries</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8">
          {testimonials.map((testimonial, index) => (
            <motion.blockquote
              key={index}
              className="bg-muted/30 border-l-4 border-gold-500 p-5 sm:p-8 rounded-r-lg min-w-0"
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <p className="font-serif text-lg text-foreground/80 italic mb-4">
                "{testimonial.quote}"
              </p>
              <footer className="text-primary font-medium">
                — {testimonial.author}
              </footer>
            </motion.blockquote>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
